<template>
  <div class="contact-list">
    <div v-for="c in contacts" :key="c.id" class="contact-wrapper">
      <RadioButton v-model="currentContact" :value="c.id"></RadioButton>
      <ContactCard :contact="c"></ContactCard>
    </div>
  </div>
</template>

<script>
import ServiceManager from "../services/service-manager";
import ContactCard from "./ContactCard.vue";
import { RadioButton } from "clariant-vue3-forms";

export default {
  name: "ContactList",
  components: {
    ContactCard,
    RadioButton,
  },
  props: ["tag"],
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      config: ServiceManager.getService(this, "Config"),
      state: ServiceManager.getService(this, "State"),
      utils: ServiceManager.getService(this, "Utils"),
      dataLayer: ServiceManager.getService(this, "DataLayer"),
      contacts: [],
      currentContact: null,
    };
  },
  mounted() {
    this.loadContacts();
    this.state.set("canAdvance",  !!this.currentContact);
  },
   watch: {
        currentContact (val) {
            this.state.set("canAdvance",  !!val);
        }
    },
  methods: {
    canAdvance() {
      return !!this.currentContact;
    },
    getNextStep() {
      this.updateState();
      return 6;
    },
    loadContacts() {
      let loader = this.utils.showLoader(".contact-list");
      this.dataLayer.loadContacts(this.tag)
        .then((res) => {
          this.contacts = res.data;
        })
        .catch((err) => {
          this.utils.showStatusMessage(
            `Could not load contacts. Error: ${err.message}.`,
            "red"
          );
        })
        .finally(() => {
          this.utils.removeLoader(loader);
        });
    },
    updateState() {
      this.state.atomicUpdate("reload", {bu: this.tag, bl: "", currentContact: this.currentContact, currentProduct: ""});
    }
  },
};
</script>

<style scoped>
.contact-list.visible {
    display: flex;
    flex-direction: row !important;
    flex-wrap: wrap;
}
.contact-wrapper {
    width: 50%;
    display: flex;
    margin: 10px 0;
    align-items: center;
}
</style>
